export { CustomError as default } from '@benzinga/templates';
